"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var NavItem = function (_a) {
    var id = _a.id, label = _a.label, href = _a.href, isActive = _a.isActive, isMobile = _a.isMobile, onClick = _a.onClick, submenu = _a.submenu, transform = _a.transform, onMouseEnter = _a.onMouseEnter, children = _a.children;
    var getTransform = function () {
        if (transform) {
            return transform;
        }
        return submenu.align === 'center' ? 'translateX(-50%)' : undefined;
    };
    return (React.createElement("div", { className: "l-mega-v2__navitem " + (submenu ? 'l-mega-v2__submenu' : '') },
        href ? (React.createElement("a", { href: href, onMouseEnter: onMouseEnter, className: "navBtn" },
            React.createElement("span", null, label))) : (React.createElement("div", { onClick: onClick, onMouseEnter: onMouseEnter, className: "navBtn" },
            React.createElement("span", null, label))),
        submenu && children && (React.createElement("div", { className: "c-mm-submenu " + (isActive ? 'c-mm-submenu--active' : ''), style: {
                top: '90%',
                left: submenu.align === 'left' ? 0 : submenu.align === 'center' ? '50%' : undefined,
                right: submenu.align === 'right' ? 0 : undefined,
                transform: getTransform(),
            } }, children))));
};
exports.default = NavItem;
